import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  ErrorHandler,
  Injector,
  ModuleWithProviders,
  NgModule,
} from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { ModelsModule } from '@nibtravel/shared/util/models';

import { ErrorService } from './error/error.service';
import { GlobalErrorHandler } from './error/global-error.handler';
import { NibtravelHttpInterceptor } from './error/nibtravel-http.interceptor';
import { LoggerService } from './logger.service';
import { LOGGING_PROVIDER } from '@nibtravel/shared/util/constants';
import { LoggerProvider } from './logger.provider';

/**
 * Module responsible for encapsulating the external logger.
 *
 * @export
 * @class LoggerModule
 */
@NgModule({
  imports: [CommonModule, ModelsModule, NgxsModule],
  providers: [ErrorService, LoggerService],
})
export class LoggerModule {
  static forRoot(): ModuleWithProviders<LoggerModule> {
    return {
      ngModule: LoggerModule,
      providers: [
        ErrorService,
        LoggerService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: NibtravelHttpInterceptor,
          multi: true,
        },
        {
          provide: ErrorHandler,
          useClass: GlobalErrorHandler,
          deps: [Injector],
        },
        {
          provide: LOGGING_PROVIDER,
          useExisting: LoggerProvider,
        },
      ],
    };
  }
}
